import {
	Col,
	FieldWrapper,
	Select,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeaderCell,
	TableRow,
	Text,
} from '@mlc/web-ui-toolkit';
import _ from 'lodash';
import React, { useState } from 'react';
import { PlanCategory } from '../../../../../../logic/domains/planProfile.domain';
import { asNumber, asTodaysDate } from '../../../../../common/formatter';
import { BenefitGroupsContent as content } from './StaticContent';
import planProfileTestIds from '../../PlanProfile.elements';

interface Props {
	planCategories: PlanCategory[];
}

const groupStatuses = [
	{ label: content.select.options.all, value: content.select.options.all },
	{ label: content.select.options.open, value: content.select.options.open },
	{
		label: content.select.options.closed,
		value: content.select.options.closed,
	},
];

const BenefitGroups: React.FunctionComponent<Props> = props => {
	const [selectedStatus, setSelectedStatus] = useState<string>(
		groupStatuses[0].value
	);

	const filterByPlanStatus = (plans: PlanCategory[], status: string) => {
		return _.filter(plans, plan => {
			return plan.status === status;
		});
	};

	const hasMembers = (plan: PlanCategory) => plan.members > 0;

	const sortByPlanName = (plans: PlanCategory[]) => {
		return _.sortBy(plans, ['name']);
	};

	const openPlans = sortByPlanName(
		filterByPlanStatus(props.planCategories, content.select.options.open)
	);
	const closedPlans = sortByPlanName(
		filterByPlanStatus(
			props.planCategories,
			content.select.options.closed
		).filter(hasMembers)
	);
	const allPlans = openPlans.concat(closedPlans);

	const handleBenefitGroupFilter = (event: any) => {
		setSelectedStatus(event.target.value);
	};

	const getPlansByStatus = () => {
		return selectedStatus === content.select.options.open
			? openPlans
			: selectedStatus === content.select.options.closed
			? closedPlans
			: allPlans;
	};

	return (
		<React.Fragment>
			<Text
				data-id={planProfileTestIds.memberDemoBenefitAsAtDate}
				el="h5"
				fontWeight="semibold"
				marginTop={7}
				marginBottom={4}
			>
				{content.heading}
				{asTodaysDate()}
			</Text>
			<Col col={4} marginBottom={4} marginTop={4} noGutter>
				<FieldWrapper label={content.select.label}>
					<Select
						onChange={handleBenefitGroupFilter}
						value={selectedStatus}
						data-id={content.select.id}
						options={groupStatuses}
					/>
				</FieldWrapper>
			</Col>

			<Table
				border="mlcBorderThin"
				borderColor="mlcAlmostWhite"
				layout="fixed"
				variant="bottomLines"
			>
				<TableHead>
					<TableRow>
						<TableHeaderCell>{content.table.staffGroupsHeader}</TableHeaderCell>
						<TableHeaderCell>{content.table.investorsHeader}</TableHeaderCell>
						<TableHeaderCell>{content.table.statusHeader}</TableHeaderCell>
					</TableRow>
				</TableHead>
				<TableBody
					data-id={planProfileTestIds.memberDemoPlanCategories}
					margin={0}
				>
					{_.map(getPlansByStatus(), (plan, idx) => {
						return (
							<TableRow key={idx}>
								<TableCell data-id={planProfileTestIds.memberDemoPlanName}>
									{plan.name}
								</TableCell>
								<TableCell data-id={planProfileTestIds.memberDemoPlanMembers}>
									{asNumber(plan.members)}
								</TableCell>
								<TableCell data-id={planProfileTestIds.memberDemoPlanStatus}>
									{plan.status}
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</React.Fragment>
	);
};

export default BenefitGroups;
